export const hexToRgba = (hex: string, opacity: number) => {
  const modifiedHex = hex.replace('#', '')

  const r = Number.parseInt(modifiedHex.slice(0, 2), 16)
  const g = Number.parseInt(modifiedHex.slice(2, 4), 16)
  const b = Number.parseInt(modifiedHex.slice(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${opacity})`
}
